var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8061)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_8061",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_8061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9999 49.0235C23.3738 49.0238 21.7517 48.8603 20.1584 48.5352C17.0855 47.9059 14.1665 46.6776 11.5682 44.9205C7.70579 42.3133 4.68244 38.6417 2.86445 34.351C2.25015 32.8977 1.78126 31.3872 1.46465 29.8415C0.813866 26.6466 0.813866 23.3533 1.46465 20.1584C2.09402 17.0855 3.32226 14.1665 5.07936 11.5682C7.68665 7.70579 11.3582 4.68244 15.6489 2.86445C17.1022 2.25013 18.6127 1.78124 20.1584 1.46465C23.3533 0.813866 26.6466 0.813866 29.8415 1.46465C32.9144 2.09402 35.8334 3.32226 38.4317 5.07936C42.2941 7.68665 45.3175 11.3582 47.1354 15.6489C47.7498 17.1022 48.2187 18.6127 48.5352 20.1584C49.186 23.3533 49.186 26.6466 48.5352 29.8415C47.9059 32.9144 46.6776 35.8334 44.9205 38.4317C42.3133 42.2941 38.6417 45.3175 34.351 47.1354C32.8977 47.7498 31.3872 48.2187 29.8415 48.5352C28.2482 48.8603 26.6261 49.0238 24.9999 49.0235ZM15.9158 12.9631C14.4516 12.9631 13.2605 14.2013 13.2605 15.7233V35.0451C13.2605 36.5671 14.4518 37.8054 15.9158 37.8054H26.538V35.0451H15.9158V15.7227H26.538V12.9625L15.9158 12.9631ZM21.2272 24.004V26.7642H34.7306L31.3049 30.3251L33.1769 32.2845L39.8159 25.3842L33.1769 18.4836L31.3049 20.4295L34.7306 24.0037L21.2272 24.004Z",
    fill: "#F9F9F9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.c019b7b13852721a922dfabe24051117.svg";
export { ForwardRef as ReactComponent };